import { generateListItems, generateTitle, getUSDPrice } from "../packageDataHelpers";
import type { IPackagesPrice } from "../types";
import { ADsPackageId, CIPackageId, SEOPackageId } from "../types";

import {
    COMP_INTEL_FEATURE_COUNT,
    COMP_INTEL_SEO_FEATURE_COUNT,
    COMP_INTEL_ADS_FEATURE_COUNT,
    TRANSLATION_KEYS,
} from "./constants";

export { getUSDPrice } from "../packageDataHelpers";

interface IPackageItem {
    title: string;
    packageId: string;
    price: string;
    recommendedTag?: boolean;
    list: Array<{ item: string }>;
}

export const getPackagesData = (packages?: IPackagesPrice): IPackageItem[] => {
    const compIntelSeoAeoTitle = generateTitle([
        TRANSLATION_KEYS.compIntelTitle,
        TRANSLATION_KEYS.compIntelSeoTitleSuffix,
        TRANSLATION_KEYS.compIntelAeoTitleSuffix,
    ]);
    const compIntelSeoAeoItems = generateListItems(COMP_INTEL_SEO_FEATURE_COUNT, TRANSLATION_KEYS.compIntelSeoItems);

    return [
        {
            title: generateTitle([TRANSLATION_KEYS.compIntelTitle]),
            packageId: CIPackageId,
            price: packages ? getUSDPrice(packages.CompetitiveIntelligenceAnnually) : "0",
            list: generateListItems(COMP_INTEL_FEATURE_COUNT, TRANSLATION_KEYS.compIntelItems),
        },
        {
            title: compIntelSeoAeoTitle,
            packageId: SEOPackageId,
            recommendedTag: true,
            price: packages ? getUSDPrice(packages.CompetitiveIntelligenceSEOAnnually) : "0",
            list: compIntelSeoAeoItems,
        },
        {
            title: generateTitle([
                TRANSLATION_KEYS.compIntelTitle,
                TRANSLATION_KEYS.compIntelSeoTitleSuffix,
                TRANSLATION_KEYS.compIntelAeoTitleSuffix,
                TRANSLATION_KEYS.compIntelAdsTitleSuffix,
            ]),
            packageId: ADsPackageId,
            price: packages ? getUSDPrice(packages.ADsCompetitiveIntelligenceSEOAEOAnnually) : "0",
            list: generateListItems(COMP_INTEL_ADS_FEATURE_COUNT, TRANSLATION_KEYS.compIntelAdsItems),
        },
    ];
};
